module.exports = "<meta name=\"description\" content=\"{{seoDescription}}\">"